import { bannerSlots } from "@stubhub/broadway-foundation";
import { sva } from "@stubhub/broadway-foundation/css";

export const demandTrendBannerRecipe = sva({
  slots: bannerSlots,
  className: "demandTrendBanner",
  base: {
    wrapper: {
      backgroundColor: "bg.surface",
      borderBlockWidth: "primitives.25",
      borderInlineWidth: "primitives.25",
      borderBlockStyle: "solid",
      borderInlineStyle: "solid",
      borderBlockColor: "border",
      borderInlineColor: "border",
    },
    content: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      columnGap: "primitives.200",
      rowGap: "primitives.200",
    },
  },
  variants: {
    demandDirection: {
      low: {
        content: {
          "& .content-demand": {
            color: "bg.fill.success",
          },
        },
      },
      typical: {
        content: {
          "& .content-demand": {
            color: "bg.fill.warning",
          },
        },
      },
      high: {
        content: {
          "& .content-demand": {
            color: "bg.fill.error",
          },
        },
      },
    },
  },
  defaultVariants: {
    demandDirection: "high",
  },
});

const demandTrendBarSlots = ["bar", "button"] as const;
export const demandTrendBarRecipe = sva({
  slots: demandTrendBarSlots,
  className: "demandTrendBar",
  base: {
    bar: {
      width: "[72px]",
      height: "[8px]",
      position: "relative",
      backgroundGradient:
        "[linear-gradient(90deg, {colors.bg.fill.success} 0%, {colors.bg.fill.warning} 50%, {colors.bg.fill.error} 100%)]",
      borderStartRadius: "element.default",
      borderEndRadius: "element.default",
      tablet: {
        width: "[128px]",
      },
    },
    button: {
      position: "absolute",
      insetBlockStart: "[50%]",
      insetInlineStart: "[50%]",
      width: "[12px]",
      height: "[12px]",
      backgroundColor: "bg.surface",
      borderBlockWidth: "primitives.50",
      borderInlineWidth: "primitives.50",
      borderBlockStyle: "solid",
      borderInlineStyle: "solid",
      borderBlockColor: "bg.surface",
      borderInlineColor: "bg.surface",
      borderStartRadius: "full",
      borderEndRadius: "full",
      transform: "translateX(-50%) translateY(-50%)",
      boxShadow: "raised",
    },
  },
  variants: {
    demandDirection: {
      low: {
        button: {
          insetInlineStart: "[0%]",
          borderBlockColor: "bg.fill.success",
          borderInlineColor: "bg.fill.success",
        },
      },
      typical: {
        button: {
          insetInlineStart: "[50%]",
          borderBlockColor: "bg.fill.warning",
          borderInlineColor: "bg.fill.warning",
        },
      },
      high: {
        button: {
          insetInlineStart: "[100%]",
          borderBlockColor: "bg.fill.error",
          borderInlineColor: "bg.fill.error",
        },
      },
    },
  },
  defaultVariants: {
    demandDirection: "high",
  },
});
